import React, { useState, useEffect } from 'react';
import { Modal, Button, Checkbox, FormGroup, FormControlLabel, Box, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(3),
        minWidth: 600,
        maxHeight: '80vh',
        overflow: 'auto',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
    },
    column: {
        padding: theme.spacing(2),
    },

    stickyFooter: {
        position: 'sticky',
        bottom: 0,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        marginTop: 'auto',
    },
}));

const ModalSelectionRatesAndRoomTypes = ({ open, onClose, onConfirm, roomTypes, activeRates, rateId, roomTypeId}) => {
    const classes = useStyles();
    const [selectedRoomTypes, setSelectedRoomTypes] = useState([]);
    const [selectedRates, setSelectedRates] = useState([]);

    const handleRoomTypeToggle = (roomTypeId) => {
        setSelectedRoomTypes(prev =>
            prev.includes(roomTypeId)
                ? prev.filter(id => id !== roomTypeId)
                : [...prev, roomTypeId]
        );
    };

    const handleRateToggle = (rateId) => {
        setSelectedRates(prev =>
            prev.includes(rateId)
                ? prev.filter(id => id !== rateId)
                : [...prev, rateId]
        );
    };

    useEffect(() => {
        handleRoomTypeToggle(roomTypeId);
        handleRateToggle(rateId);
    }, [])

    const selectAllRoomTypes = () => {
        setSelectedRoomTypes(roomTypes.map(rt => rt.id));
    };

    const deselectAllRoomTypes = () => {
        setSelectedRoomTypes([]);
    };

    const selectAllRates = () => {
        setSelectedRates(activeRates.map(rate => rate.id));
    };

    const deselectAllRates = () => {
        setSelectedRates([]);
    };

    const handleConfirm = () => {
        if (selectedRoomTypes.length === 0) {
            alert('Выберите хотя бы одну категорию');
            return;
        }

        if (selectedRates.length === 0) {
            alert('Выберите хотя бы один тариф');
            return;
        }

        onConfirm(selectedRoomTypes, selectedRates);
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose} className={classes.modal}>
            <div className={classes.paper}>
                <h2>Выбор категорий и тарифов</h2>

                <Grid container spacing={3}>
                    <Grid item xs={6} className={classes.column}>
                        <Box mb={2}>
                            <Button size="small" onClick={selectAllRoomTypes} style={{ marginRight: 8 }}>
                                Все
                            </Button>
                            <Button size="small" onClick={deselectAllRoomTypes}>
                                Ничего
                            </Button>
                        </Box>
                        <FormGroup>
                            {roomTypes.map(roomType => (
                                <FormControlLabel
                                    key={roomType.id}
                                    control={
                                        <Checkbox
                                            checked={selectedRoomTypes.includes(roomType.id)}
                                            onChange={() => handleRoomTypeToggle(roomType.id)}
                                        />
                                    }
                                    label={roomType.name}
                                />
                            ))}
                        </FormGroup>
                    </Grid>
                    <Grid item xs={6} className={classes.column}>
                        <Box mb={2}>
                            <Button size="small" onClick={selectAllRates} style={{ marginRight: 8 }}>
                                Все
                            </Button>
                            <Button size="small" onClick={deselectAllRates}>
                                Ничего
                            </Button>
                        </Box>
                        <FormGroup>
                            {activeRates.map(rate => (
                                <FormControlLabel
                                    key={rate.id}
                                    control={
                                        <Checkbox
                                            checked={selectedRates.includes(rate.id)}
                                            onChange={() => handleRateToggle(rate.id)}
                                        />
                                    }
                                    label={rate.name}
                                />
                            ))}
                        </FormGroup>
                    </Grid>
                </Grid>

                <Box className={classes.stickyFooter} display="flex" justifyContent="flex-end">
                    <Button onClick={onClose} style={{ marginRight: 8 }}>
                        Отмена
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleConfirm}>
                        OK
                    </Button>
                </Box>
            </div>
        </Modal>
    );
};

export default ModalSelectionRatesAndRoomTypes;
